import getValue from 'get-value'
import { DateTime } from 'luxon'

export function value<Type extends object>(desc: string | ((t: Type) => string | React.ReactElement), target: Type | null): React.ReactElement {

  if (target === null) {
    return <>—</>
  }

  let ret
  if (typeof desc === 'string') {
    ret = getValue(target, desc)
  } else if (typeof desc === 'function') {
    ret = desc(target)
  } else {
    ret = desc
  }

  if (!ret) {
    return <>—</>
  }

  if (/^\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d[0-9.]*Z$/.test(`${ret}`)) {
    ret = DateTime.fromISO(ret).toLocaleString(DateTime.DATETIME_FULL)
  }
  return <>{ret}</>
}
